/* Code from HPDevCo */
window.addEventListener('message', function (event) {
    if (event.data) {
        var iframe = document.querySelector('#dmc-iframe-wpr');
        const headerHeight = document.querySelector('.header__main') ? document.querySelector('.header__main').offsetHeight : 0;
        if (iframe) {
            if (event.data.isStackMapPage) {
                iframe.classList.add('stack-map-active');
            } else {
                iframe.classList.remove('stack-map-active');

                // Calculate the position to scroll, considering header height
                const sectionPosition = iframe.getBoundingClientRect().top + window.pageYOffset - headerHeight - 90;
                // Scroll to the calculated position with smooth behavior
                window.scrollTo({
                    top: sectionPosition,
                    behavior: "smooth"
                });

            }
        }
    }
}, false);
/* End HPDevCo Code */

var iframe = document.querySelector('#dmc-iframe-wpr');
if (iframe) {
    iframe.parentElement.classList.add('map-wrap');
}
